import React from 'react'
import { Link, usePage } from '@inertiajs/react'
import Layout from '../../components/Layout'
import { canViewPolo } from '../../lib/permissions'

export default function PolosIndex({ polos }) {
  const { auth } = usePage().props
  const canView = canViewPolo(auth?.user)

  const nivel1 = polos.filter(p => p.nivel === 1)
  const nivel2 = polos.filter(p => p.nivel === 2)

  const PoloList = ({ polos, nivel, emptyMessage }) => (
    <div className="card overflow-hidden">
      <div className={`px-4 py-3 ${nivel === 1 ? 'bg-brand-dark' : 'bg-brand-light'} text-white`}>
        <h2 className="font-semibold">Polos Nível {nivel}</h2>
      </div>
      <ul className="divide-y divide-gray-100">
        {polos.map(polo => (
          <li key={polo.id}>
            {canView ? (
              <Link
                href={`/polos/${polo.id}`}
                className="block px-4 py-3 link-subtle hover:bg-gray-50"
              >
                {polo.nome}
              </Link>
            ) : (
              <span
                className="block px-4 py-3 text-gray-500"
                title="Solicite autorização para visualizar este polo"
              >
                {polo.nome}
              </span>
            )}
          </li>
        ))}
        {polos.length === 0 && (
          <li className="px-4 py-3 text-gray-500 italic">
            {emptyMessage}
          </li>
        )}
      </ul>
    </div>
  )

  return (
    <Layout>
      <div className="py-8">
        <h1 className="text-2xl font-bold text-brand-dark mb-6 font-heading">Polos</h1>

        <div className="grid md:grid-cols-2 gap-6">
          <PoloList
            polos={nivel1}
            nivel={1}
            emptyMessage="Nenhum polo nível 1 encontrado"
          />
          <PoloList
            polos={nivel2}
            nivel={2}
            emptyMessage="Nenhum polo nível 2 encontrado"
          />
        </div>
      </div>
    </Layout>
  )
}
